import { gql } from "@apollo/client";

export const ADD_INVOICE_NOTE = gql`
  mutation addInvoiceNote($bookingId: String! $note:String!, $invoiceId: String) {
    addInvoiceNote(bookingId: $bookingId, note:$note, invoiceId: $invoiceId)
  }
`;